<template>
  <div>
    <StepsBar :currentStep="currentStep" />
    <!-- 其他页面内容 -->
  </div>
  <div class="login">
    <div class="background-image"></div>
    <div class="title-box">
      <h1 class="title-text">{{ $t('account_cancellation_title') }}</h1>
    </div>
      
    <div class="login-container">
      <div class="login-box">
        <!-- <h2 class="login-title">{{ $t('title') }}</h2> -->
        
        <form class="login-form" @submit.prevent="login">
          <input v-model="username" type="text" :placeholder="$t('username')" class="login-input">
          <input v-model="password" type="password" :placeholder="$t('password')" class="login-input">
          <button type="submit" class="login-button">{{ $t('button_login') }}</button>
        </form>
        <div class="divider"></div>
        
        <!-- data-context="signin"
            data-ux_mode="redirect"
            data-auto_prompt="false"
            data-login_uri="/api/v1/userweb/login_google" -->
        <div id="g_id_onload"
          data-client_id="425913069705-7vaoh3nh7m48ohhkso5met0suag2lmf7.apps.googleusercontent.com"
          data-callback="handleCredentialResponse"
          data-auto_prompt="false">
        </div>
        <div class="g_id_signin"
            data-locale="en"
            data-type="standard"
            data-shape="rectangular"
            data-theme="outline"
            data-text="signin_with"
            data-size="large"
            data-logo_alignment="left">
        </div>
        <!-- <div class="g-signin2"  data-longtitle="true" data-lang="en"  data-onsuccess="onSignIn"></div> -->
      </div>
    </div>
  </div>
</template>


<script>
import instance from '@/util/axios.js';
import { setLocal, getLocal, removeLocal } from '@/util/help.js';
import StepsBar from '@/components/StepsBar.vue';

export default {
  name: 'LoginComponent',
  components: {
    StepsBar
  },
  data() {
    return {
      username: '',
      password: '',
      currentStep: 1
    };
  },
  mounted() {
    // 在组件挂载时调用 getToken() 函数来获取 CSRF Token
    this.getToken();
    // window.google.accounts.id.initialize({
    //   client_id: '425913069705-7vaoh3nh7m48ohhkso5met0suag2lmf7.apps.googleusercontent.com',
    //   callback: this.handleCredentialResponse,
    // });
    window.handleCredentialResponse = this.handleCredentialResponse;
  },
  methods: {
    handleCredentialResponse(response) {
      // 在这里执行与原始JavaScript代码中的相同操作

      instance.post("/api/v1/userweb/login_google", {
        credential: response.credential,
      })
      .then(response => {
        // 响应成功
        
        if (response.data.status == 0) {
          const data = response.data.data
          setLocal("auth", data.username)
          setLocal("servers", data.servers)
          removeLocal("read_agreement")
          this.$router.push("/user");
        } else {
          alert(this.$t("error_login_fail"));  // 登录失败，请稍后再试
          this.$router.push("/login");
        }
      })
      .catch(error => {
        // 登录失败
        alert(this.$t("error_server_response")); // 服务器响应失败，请稍后再试
        console.log(error);
        this.$router.push("/login");
      });

    },
    getToken() {
      instance.get("/api/v1/userweb/get_csrf_token")
      .then(response => {
          if (response.data.status == 0) {
              const data = response.data.data
              if (data.username && data.username == getLocal("auth")) {
                this.$router.push("/user");
              }
              
              // setLocal("csrfToken", data.csrfToken)
              // setLocal("csrfToken", response.headers['x-csrf-token'])
          } else {
            alert(this.$t("error_exception")); // 页面异常，请重新刷新页面
            console.log(response.data.status);
          }
      })
      .catch(error => {
          alert(error)
          this.$router.push("/maintain");
      })
    },
    login() {
      
      if (this.username == "" || this.password == "") {
        alert(this.$t("error_null_username_or_password")) // 用户名或密码不能为空
        return
      }
      // 发送登录请求 http://192.168.2.73:8089/login
      instance.post("/api/v1/userweb/login", {
        username: this.username,
        password: this.password
      })
      .then(response => {
        // 登录成功
        
        if (response.data.status == 0) {
          setLocal("auth", this.username)
          const data = response.data.data
          setLocal("servers", data.servers)
          removeLocal("read_agreement")
          this.$router.push("/user/agreement");
        } else if (response.data.status == 50001) {
          alert(this.$t("error_username_or_password"));  // 用户名或密码不正确，请重新输入
        } else if (response.data.status == 50005) {
          alert(this.$t("error_many_login")); // 多次尝试登录失败，请24小时后再试
        } else {
          alert(this.$t("error_login_fail"));  // 登录失败，请稍后再试
          console.log(response.data.status);
          this.$router.push("/login");
        }
      })
      .catch(error => {
        // 登录失败
        alert(this.$t("error_server_response")); // 服务器响应失败，请稍后再试
        console.log(error);
        this.$router.push("/login");
      });
    }
  }
};
</script>

<style scoped>
.login {
  text-align: center;
}
.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('../../public/images/back.jpg');
  background-size: cover;
  background-position: center;
  filter: blur(8px);
  z-index: -1;
}

.title-box {
    text-align: center;
    padding: 20px;
    width: 1229px;
    margin: 0 auto; /* 这个属性将使元素水平居中 */
}

.title-text {
  text-align: center;
  font-size: 50px;
}

.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;  /* 垂直方向上向上，center为居中 */
  position: relative;
  width: 1229px;
  margin: 0 auto; /* 这个属性将使元素水平居中 */
}

.login-box {
  width: 400px;
  padding: 40px;
  background: linear-gradient(to bottom, #b3b2b2, #ffffff);;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.login-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
}

.login-form {
  display: flex;
  flex-direction: column;
}

.login-input {
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.login-button {
  padding: 10px 20px;
  background-color: #428bca;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.login-button:hover {
  background-color: #3071a9;
}

/* 分割线样式 */
.divider {
  margin: 20px 0;
  border-top: 1px solid #ccc;
}
</style>
  